module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-nav', {
    attrs: {
      "tabs": ""
    }
  }, [_c('b-nav-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedProject),
      expression: "selectedProject"
    }],
    attrs: {
      "active": _vm.currentTab && _vm.currentTab === 'requirements'
    },
    on: {
      "click": function($event) {
        _vm.pushTheState('requirements')
      }
    }
  }, [_vm._v("Requirements")]), _vm._v(" "), _c('b-nav-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedProject),
      expression: "selectedProject"
    }],
    attrs: {
      "active": _vm.currentTab && _vm.currentTab === 'traceability'
    },
    on: {
      "click": function($event) {
        _vm.pushTheState('traceability')
      }
    }
  }, [_vm._v("Traceability Matrix")]), _vm._v(" "), _c('b-nav-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedProject),
      expression: "selectedProject"
    }],
    attrs: {
      "active": _vm.currentTab && _vm.currentTab === 'baselines'
    },
    on: {
      "click": function($event) {
        _vm.pushTheState('baselines')
      }
    }
  }, [_vm._v("Baselines")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "project-selection"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.projectsArray
    },
    model: {
      value: (_vm.selectedProject),
      callback: function($$v) {
        _vm.selectedProject = $$v
      },
      expression: "selectedProject"
    }
  })], 1), _vm._v(" "), (_vm.currentProjectIsGlobal) ? _c('div', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "title": "Global Requirements is a special project automatically created for you that allows you to link to issues across your whole Jira instance (not just within a single project)"
    }
  }, [_c('icon', {
    attrs: {
      "id": "global-icon",
      "name": "info-circle"
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08f9d614"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppNav.vue
// module id = 995
// module chunks = 1